export const managedPlacementToAd = (campaign, fallback) => {
  if (!campaign || !campaign.creative) return fallback;
  const cr = campaign.creative;
  return {
    ...fallback,
    id: String(campaign._id),
    managedCampaignId: String(campaign._id),
    title: cr.title || campaign.name || fallback?.title,
    description: cr.description || fallback?.description,
    image: cr.imageUrl || fallback?.image,
    url: cr.destinationUrl || fallback?.url,
    sponsor: campaign.advertiserName || fallback?.sponsor,
    cta: cr.ctaLabel || fallback?.cta,
  };
};
